import * as Actions from "./constants";
import { put, call, takeEvery, all } from "redux-saga/effects";
import { getAllSubscriptionOrders } from "./service";
/**
 * Load all subscription
 */
function* listAllSubscriptionOrder() {
  try {
    const { data } = yield call(getAllSubscriptionOrders);
    yield put({
      type: Actions.GET_ALL_SUBSCRIPTION_ORDER_SUCCESS,
      payload: data,
    });
  } catch (error) {
    yield put({
      type: Actions.GET_ALL_SUBSCRIPTION_ORDER_ERROR,
      error: error,
    });
  }
}
export default function* subscriptionOrderSaga() {
  yield takeEvery(Actions.GET_ALL_SUBSCRIPTION_ORDER, listAllSubscriptionOrder);
}
